'use client';

import { projectsConfig } from '@/features/projects/projects.config';
import type { GetProject } from '@/server/api/rest/project';
import { useLocalePath } from '@/shared/hooks';
import { useT } from 'next-i18next/client';
import Image from 'next/image';
import Link from 'next/link';
import type { FC } from 'react';

type ProjectCardProps = {
  readonly project: NonNullable<GetProject>;
  readonly images: GetProject['images'];
  readonly slug?: GetProject['slug'];
};

export const ProjectCard: FC<ProjectCardProps> = ({
  images,
  project,
  slug,
}) => {
  const { t } = useT(projectsConfig.i18nNamespaces);
  const { to } = useLocalePath();
  const defaultImg = '/images/tend.png';

  return (
    <Link
      href={to(`/project/${slug}`)}
      className="group block"
    >
      <div
        className="p-px rounded-[13px]"
        style={{ background: 'linear-gradient(rgba(255,255,255,0.2), rgba(255,255,255,0.05), rgba(0,0,0,0))' }}
      >
        <div className="bg-white/5 backdrop-blur-[12px] rounded-[12px] overflow-hidden">
          <Image
            key={images[2]?.url ?? defaultImg}
            src={images[2]?.url ?? defaultImg}
            className="w-full object-cover aspect-[4/3] group-hover:scale-[1.03] transition-transform duration-500"
            alt={project.title}
            loading={'eager'}
            width={430}
            height={294}
          />
          <div className="p-6">
            <h3 className="text-base font-medium text-white group-hover:text-[#F24E1E] transition-colors">
              {project.title}
            </h3>
            <p className="mt-2 text-sm text-white/60">{project.subtitle}</p>
            <span className="mt-4 inline-block text-sm text-[#F24E1E]">
              {t('projects:btn.viewCaseStudy')} →
            </span>
          </div>
        </div>
      </div>
    </Link>
  );
};
